// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_t6-0";
export var checkoutRateBadgeLink = "_t6-1";